import {findImageGroupBy} from '@salesforce/retail-react-app/app/utils/image-groups-utils'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {ProductDataType} from '@/types/product'

interface ProductDataForTile extends ProductDataType {
    slugUrl: string
    c_averageRating: number
    c_totalReviews: number
}

export const formatProductDataForTile = (productData: ProductDataForTile) => {
    const siteId = getConfig().app.commerceAPI.parameters.siteId as string
    const image = findImageGroupBy(productData.imageGroups, {
        viewType: 'large'
    })?.images?.[0]

    const startIndex = image.link.indexOf('/on/demandware')

    if (startIndex == -1) {
        console.error('Product image not found for product with id: ', productData.id)
    }
    const image_url = image.link.substring(startIndex)
    const slug = productData.slugUrl.split(siteId)[1] || ''

    return {
        ...productData,
        url: `https://${siteId.toLowerCase()}.com${slug}`,
        image_url,
        rating: productData.c_averageRating,
        number_of_reviews: productData.c_totalReviews
    }
}

/**
 * Determines if the current date falls within the specified schedule range.
 *
 * The function checks the provided `scheduleFrom` and `scheduleTo` dates to
 * determine if the current date is within the active range for the promotion
 * or schedule.
 *
 * @param {string | undefined} scheduleFrom - The start date of the schedule in ISO string format, or null if not provided.
 * @param {string | undefined} scheduleTo - The end date of the schedule in ISO string format, or null if not provided.
 *
 * @returns {boolean} - Returns `true` if the current date is within the schedule range,
 *                      `false` otherwise. If both dates are `null`, it returns `true`.
 */

export const isScheduled = (scheduleFrom, scheduleTo) => {
    let result = false
    const currentDate = new Date()
    // Parse the scheduleFrom and scheduleTo into Date objects if they are not null
    const parsedFrom = scheduleFrom ? new Date(scheduleFrom) : null
    const parsedTo = scheduleTo ? new Date(scheduleTo) : null

    if (parsedFrom === null && parsedTo === null) {
        result = true
    } else if (parsedFrom !== null && parsedTo !== null) {
        result = currentDate <= parsedTo && currentDate >= parsedFrom
    } else if (parsedFrom === null && parsedTo !== null) {
        result = currentDate <= parsedTo
    } else if (parsedFrom !== null && parsedTo === null) {
        result = currentDate >= parsedFrom
    }
    return result
}
